async function setUpTryNowQuickBuy(){
  if(!window.trynow) return;

  const hasPassedTryLink = await window.trynow.hasPassedTryLink();
  const tryNowSellingPlan = (await window.trynow.getSellingPlanId()).split('/').pop();
  const isTryNowCollection = window.location.href.includes('try-before-you-buy');
  let detailButtonChangesApplied = false
  if (!(hasPassedTryLink && isTryNowCollection)) return;

  function changeModal() {
    const originalBtn = document.querySelector('.x-block-view-detail .add_to_cart_button');
    if (!originalBtn) return;
    originalBtn.textContent = 'Try Before You Buy';

    originalBtn.addEventListener('click', async () => {
      await window.trynow.addToCartClicked();
    });
  
    const parent = originalBtn.closest('.x-block-view-detail');
    if (!parent) return;
    
    const siblingWithForm = parent.parentNode.querySelector('[x-ref="product_form_container"]');
    if (!siblingWithForm) return;
  
    const form = siblingWithForm.querySelector('form');
    if (!form) return;
  
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'selling_plan';
    hiddenInput.value = tryNowSellingPlan;
  
    form.appendChild(hiddenInput);
  }

  function applyTryNowLogic() {
    document.querySelectorAll('form[id*="product-form-choose-option"]').forEach(form => {
      if (form.querySelector('input[name="selling_plan"]')) return;
  
      const button = form.querySelector('button[name="add"]');
      if (!button || button.disabled) return;
  
      form.insertAdjacentHTML('afterbegin', `
        <input type="hidden" name="selling_plan" value="${tryNowSellingPlan}">
      `);
  
      button.textContent = 'Try Before You Buy';
      button.addEventListener('click', async () => {
        await window.trynow.addToCartClicked();
      });
    });

    document.querySelectorAll('.label-btn-quickview').forEach(button => {
      if (button._listenerAttached) return;
      button.addEventListener('click', function () {
        setTimeout(() => {
          changeModal();
        }, 1000)
      });
      button._listenerAttached = true;
    });
    
  }

  const observer = new MutationObserver(() => {
    applyTryNowLogic();
  });

  observer.observe(document.querySelector('#items-grid'), {
    childList: true,
    subtree: true,
  });

  applyTryNowLogic();
}

window.addEventListener('load', setUpTryNowQuickBuy);
